import { NgModule } from "@angular/core";
import { ImgPipe } from "./img/img.pipe";
import { SafePipe } from "./html-safe/html-safe.pipe";
import { PropStringifyPipe } from "./propStringify/prop-stringify.pipe";
import { PermissionNamePipe } from "./permission-name/permission-name.pipe";

@NgModule({
  declarations: [SafePipe, ImgPipe, PropStringifyPipe, PermissionNamePipe],
  imports: [],
  exports: [SafePipe, ImgPipe, PropStringifyPipe, PermissionNamePipe]
})
export class PipesComponentsModule {}
